// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag-1F1K8","percent":"percent-2E4g7"};